/* eslint-disable import/prefer-default-export */

export const extraTableIdentificatorList = [
  'Email:',
  'Telegram Id:',
];
